import { deepCompare } from "@website/utils/deep-compare";
import { ReserveHostPoliciesPropertiesTypes } from "@website/widget/reserve-host-policies/reserve-host-policies.types";
import { memo } from "react";

const Component = (properties: ReserveHostPoliciesPropertiesTypes) => {
  const { rules } = properties;
  const trimmedRules = rules?.trim() || "";
  if (!trimmedRules || trimmedRules?.length < 2) return null;

  return (
    <div className="flex w-full flex-col gap-4" id="hotel_policies">
      <h2 className="text-subtitle-1 md:text-headline-6">قوانین میزبان</h2>
      <div className="text-body-2 text-on-surface-high-emphasis whitespace-pre-wrap break-words">
        {trimmedRules}
      </div>
    </div>
  );
};
export const ReserveHostPolicies = memo(Component, deepCompare);
